import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppLayout } from '../components/layout';

const MainLayout: React.FC = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default MainLayout;
